/**
 * Entry point de l'app GGVie consulting standalone (SD-3875).
 *
 * Cette app est build-able indépendamment (`vite build --config
 * vite.ggvie.config.ts`) pour être déployée comme SPA chez le client.
 * Sentry est initialisé avant le routeur (no-op sans DSN, cf. `sentry.ts`).
 */
import { createApp } from 'vue'

import App from './App.vue'
import { router } from './router'
import { initSentry } from './sentry'

import '@ggvie-consulting/styles/chat.css'
import '@ggvie-consulting/styles/design-tokens.css'

console.info(`[ggvie] build ${__BUILD_COMMIT__} (${__BUILD_TIMESTAMP__})`)

const app = createApp(App)
initSentry(app, router)
app.use(router)
app.mount('#app')
